import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";

import React from "react";
import { withRouter } from "react-router-dom";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// TODO: Refactor this to some sharable component
import DynamicIcons from "@pages/home/v4/footer/dynamicIcons";

import { FooterProviderIconWrapper, ProviderImgWrapper } from "./elements.jsx";
import useController from "./useController.js";

const swiperOptions = {
	modules: [Pagination, Navigation],
	speed: 400,
	spaceBetween: 30,
	slidesPerView: "auto",
	slidesOffsetBefore: 20,
	slidesOffsetAfter: 20,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
};

const ProvidersSlider = (props) => {
	const {
		state: { providers, slidesPerGroup },
		handlers: { handleSelectProvider },
	} = useController(props);

	return (
		<ProviderImgWrapper isSvgProviders={window.MARS_PROVIDERS}>
			<Swiper
				slidesPerView={1}
				lazyPreloadPrevNext={1}
				slidesPerGroup={slidesPerGroup}
				modules={[Pagination, Navigation]}
				{...swiperOptions}>
				{providers?.map((provider, index) => (
					<SwiperSlide
						key={index}
						onClick={() => handleSelectProvider(provider)}>
						{window.MARS_PROVIDERS ? (
							<FooterProviderIconWrapper>
								<DynamicIcons
									key={`provider-${provider}`}
									name={provider}
									subPath={"providers"}
									type={"svg"}
								/>
							</FooterProviderIconWrapper>
						) : (
							<DynamicIcons
								name={provider}
								subPath={"providers"}
								type={"png"}
							/>
						)}
					</SwiperSlide>
				))}
				<div className="swiper-button-prev"></div>
				<div className="swiper-button-next"></div>
			</Swiper>
		</ProviderImgWrapper>
	);
};

export default withRouter(ProvidersSlider);
